module.exports = __webpack_public_path__ + "img/edc-moka.c0399c68.png";